module.exports = __webpack_public_path__ + "static/media/terminal.8f4985cc.svg";